import { Column } from '@ant-design/charts';
import { Button, Card, Col, List, Result, Row, Statistic } from 'antd';
import React, { CSSProperties, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Role, User } from '../../models';
import { apiClient } from '../../utils';

export function WelcomeWidget() {
  return (
    <Card title="Hoşgeldiniz!" size="small" bordered={false} style={{ height: '100%', overflow: 'hidden' }}>
      <p>KALİTE Uygulaması'na hoşgeldiniz.</p>
      <p>Uygulamayla ilgili bilgi almak için KALİTE Birimi'yle iletişime geçebilirsiniz.</p>
    </Card>
  );
}

export function StatisticsWidget() {
  const [usersLoading, setUsersLoading] = useState(false);
  const [users, setUsers] = useState<User[]>();
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roles, setRoles] = useState<Role[]>();
  const [forbidden, setForbidden] = useState(false);

  useEffect(() => {
    loadUsers();
    loadRoles();
  }, []);

  const loadUsers = () => {
    setUsersLoading(true);
    apiClient
      .get('users')
      .then(response => {
        setUsers(response.data as User[]);
        setUsersLoading(false);
      })
      .catch(reason => {
        setUsersLoading(false);
        if (reason?.response?.status === 403) {
          setForbidden(true);
        }
      });
  };

  const loadRoles = () => {
    setRolesLoading(true);
    apiClient
      .get('roles')
      .then(response => {
        setRoles(response.data as Role[]);
        setRolesLoading(false);
      })
      .catch(reason => {
        setRolesLoading(false);
        if (reason?.response?.status === 403) {
          setForbidden(true);
        }
      });
  };

  const titleStyle: CSSProperties = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };

  return (
    <Card title="İstatistikler" size="small" bordered={false} style={{ overflow: 'hidden', height: '100%' }}>
      {!forbidden ? (
        <Row gutter={[12, 12]}>
          <Col sm={12} xxl={6}>
            <Card size="small">
              <Statistic
                title={<div style={titleStyle}>Kullanıcı</div>}
                value={users?.length}
                precision={0}
                valueStyle={{ color: '#3f8600' }}
                loading={usersLoading}
              />
            </Card>
          </Col>
          <Col sm={12} xxl={6}>
            <Card size="small">
              <Statistic
                title={<div style={titleStyle}>Rol</div>}
                value={roles?.length}
                precision={0}
                valueStyle={{ color: '#3f8600' }}
                loading={rolesLoading}
              />
            </Card>
          </Col>
        </Row>
      ) : (
        <Result status="warning" subTitle="İstatistikleri görüntülemek için yetkiniz bulunmuyor." />
      )}
    </Card>
  );
}

export function SavedSearchesWidget() {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [savedSearches, setSavedSearches] = useState<string[]>();

  useEffect(() => {
    loadSavedExecutions();
  }, []);

  const loadSavedExecutions = () => {
    setLoading(true);
    apiClient
      .get('users/me/settings/searches')
      .then(response => {
        setSavedSearches(response.data as string[]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const search = (value: string) => {
    if (!value || value.length < 3) {
      return;
    }
    history.push(`/search?s=${value}`);
  };

  return (
    <Card title="Kaydedilmiş aramalar" size="small" bordered={false} style={{ height: '100%', overflowY: 'auto' }}>
      <List
        loading={loading}
        dataSource={savedSearches}
        renderItem={(item: string) => (
          <List.Item>
            <Button type="link" onClick={() => search(item)}>
              {item}
            </Button>
          </List.Item>
        )}
      />
    </Card>
  );
}
